import Section from '@/components/Section'
import { useMemoizedContentGetter } from '@/utils/contentful'
import { Typography, LinkButton } from 'components/Contentful'

function CloserStatementSectionModule({
  title,
  subtitle,
  background,
  button,
  config = {},
  sectionVariationObject,
}) {
  const hasMediaContent = Boolean(background?.mediaContent)
  const simpleDesign = config?.simpleDesign === true

  // Configuración de estilos según simpleDesign
  const backgroundColor = simpleDesign
    ? 'bg-[#F5F7FA]'
    : hasMediaContent
    ? ''
    : 'bg-[linear-gradient(179deg,#3C14FF_-8.78%,#1DB6FF_134.86%)]'

  const textColor = simpleDesign ? 'text-[#1a1a1a]' : 'text-white'
  const minHeight = simpleDesign ? 'min-h-[400px]' : 'min-h-[700px] md:min-h-[1000px]'
  const titleSize = simpleDesign ? 'text-[32px] md:text-[48px]' : ''
  const subtitleSize = simpleDesign ? 'text-[16px] md:text-[18px]' : ''
  const buttonColor = simpleDesign ? 'primary' : 'secondary'
  const buttonClassName = simpleDesign
    ? 'bg-[#2C47F6] hover:bg-[#3730a3] text-white px-8 py-3 rounded-md'
    : 'mx-[2.4px] my-0 z-1'

  return (
    <Section
      childContainerClassName="z-1"
      className={`${backgroundColor} ${textColor} text-center ${minHeight} flex overflow-hidden [content-visibility:auto] 
        ${hasMediaContent && !simpleDesign ? 'lg:text-left' : ''} lg:min-h-[339px]`}
      data-testid="closer-statement-section"
      {...(hasMediaContent
        ? {
            mediaContent: background?.mediaContent,
            middleMediaContent: background?.mobileMediaContent,
            mobileMediaContent: background?.mobileMediaContent,
            backgroundImageAlt: background?.mediaAltText,
            backgroundObjectPositionclassName: 'bg-bottom lg:bg-top',
          }
        : {})}
      full={true}
    >
      <div
        className={`pt-8 lg:pt-0 lg:max-w-[920px] lg:min-h-[339px] lg:mx-auto ${
          config?.rightContent
            ? 'justify-end'
            : !hasMediaContent || simpleDesign
            ? 'justify-center'
            : ''
        } flex-col lg:flex-row flex items-center`}
        data-testid="closer-statement-outer-grid-container"
        data-right-content={config?.rightContent}
      >
        <div
          className="order-1 w-full lg:w-[65%] xl:w-[80%]"
          data-testid="closer-statement-grid-item-text"
        >
          <div
            className={`p-0 ${simpleDesign ? 'max-w-[800px]' : 'max-w-[450px]'}`}
            data-testid="closer-statement-text-container"
          >
            <Typography
              content={title?.textContent}
              variant="headingLg"
              fontWeight="bold"
              className={`pb-6 leading-[140%] lg:pb-8 ${titleSize}`}
            />
            {subtitle && (
              <Typography
                content={subtitle?.textContent}
                variant="bodySm"
                className={`pb-6 leading-[150%] lg:pb-8 ${subtitleSize}`}
                data-testid="closer-statement-subtitle"
              />
            )}
            <div
              className={`m-[2px] flex ${!hasMediaContent || simpleDesign ? 'justify-center' : ''}`}
            >
              {button && (
                <LinkButton
                  className={buttonClassName}
                  content={button}
                  typographicOptions={{
                    className: 'bodySm lg:bodyLg font-bold!',
                    'data-testid': 'closer-statement-button-text',
                  }}
                  size="medium"
                  color={buttonColor}
                  data-testid="closer-statment-button"
                  track={{
                    ...{
                      click_id: button?.linkText?.json?.content[0]?.content[0]?.value,
                      click_text: button?.linkText?.json?.content[0]?.content[0]?.value,
                      list_name: 'Product Page Closer',
                      click_url: button?.linkHref,
                      nav_link_section: 'Closer Statement',
                      track_event: 'internal_campaign_click',
                      click_type: 'Button Click',
                      event_action: 'button_click',
                      event_type: 'button_click',
                    },
                    ...button.event,
                    sectionVariationObject,
                  }}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </Section>
  )
}

function CloserStatementSection({ content }) {
  const sectionVariationObject = {
    ...content?.fields?.experiment,
    variant: content?.fields?.experimentVariation,
  }
  const { title, subtitle, background, button, config } = useMemoizedContentGetter(content, [
    'title',
    'subtitle',
    'background',
    'button',
    'config',
  ])

  return (
    <CloserStatementSectionModule
      title={title}
      subtitle={subtitle}
      background={background}
      button={button}
      config={config?.jsonContent}
      sectionVariationObject={sectionVariationObject}
    />
  )
}
export { CloserStatementSection, CloserStatementSectionModule }
export default CloserStatementSection
